import React from "react";

import { useNavigate, useLocation } from "react-router-dom";

import { Userpilot } from "userpilot";

import type { NavigateFunction, NavigateOptions, To } from "react-router-dom";

import { areThirdPartyToolsEnabled } from "@/utils/getEnvironment";

let navigateFunction: NavigateFunction | null = null;
export const NavigateExporter = () => {
    const navigate = useNavigate();
    const location = useLocation();
    React.useEffect(() => {
        if (areThirdPartyToolsEnabled()) {
            Userpilot.reload();
        }
    }, [location]);
    React.useEffect(() => {
        navigateFunction = navigate;
    }, [navigate]);

    return null;
};
export const router: { navigate: (to: To, options?: NavigateOptions) => void } =
    {
        navigate: (to, options) => {
            if (!navigateFunction) throw new Error("Router not initialized");
            return navigateFunction(to, options);
        },
    };
